import React, { Component, createContext } from "react";
import { firestore } from "../firebase";
import Helper from "../components/helper";
import {calendarQueryMonth} from "../lib/calendarQueryWindow.mjs";

export const PLANITEM_HISTORY_CONTEXT = createContext();

class PlanItemHISTORYProvider extends Component {
  state = { history_planItems: undefined };

  lastRequestToken = 0;

  getQueryWindow = () => {
    const focusDate = this.props.focusDate instanceof Date ? this.props.focusDate : new Date();
    const start = new Date(focusDate.getFullYear(), focusDate.getMonth() - 1, 1);
    const end = new Date(focusDate.getFullYear(), focusDate.getMonth() + 2, 0, 23, 59, 59, 999);

    return { start, end };
  };

  loadHistoryItems = async () => {
    const requestToken = ++this.lastRequestToken;
    const { start, end } = this.getQueryWindow();

    const snapshot = await firestore
      .collection(Helper.getBranchCollectionName("containers", this.props.branchCode))
      .where("deliveryDate", ">=", start)
      .where("deliveryDate", "<=", end)
      .where("state", "in", ["d", "r"])
      .get();

    if (requestToken !== this.lastRequestToken) {
      return;
    }

    const containerObjs = snapshot.docs.map(doc => {
      return { id: doc.id, routingContainerState: "h", ...doc.data() };
    });

    let notInvoicedList = containerObjs.filter(function (obj) {
      return obj.deliveryDate !== null;
    });

    notInvoicedList.sort((a, b) => Helper.compareDateLike(a.deliveryDate, b.deliveryDate));

    this.setState({ history_planItems: notInvoicedList });
  };

  componentDidMount = () => {
    this.loadHistoryItems();
  };

  componentDidUpdate = prevProps => {
    const prevFocusTime = calendarQueryMonth(prevProps.focusDate);
    const nextFocusTime = calendarQueryMonth(this.props.focusDate);
    const prevBranchCode = prevProps.branchCode || "NY";
    const nextBranchCode = this.props.branchCode || "NY";

    if (prevBranchCode !== nextBranchCode) {
      this.setState({ history_planItems: undefined }, this.loadHistoryItems);
      return;
    }

    if (prevFocusTime !== nextFocusTime) {
      this.loadHistoryItems();
    }
  };

  componentWillUnmount = () => {
    this.lastRequestToken += 1;
  };

  render() {
    const { history_planItems } = this.state;
    const { children } = this.props;

    return <PLANITEM_HISTORY_CONTEXT.Provider value={history_planItems}>{children}</PLANITEM_HISTORY_CONTEXT.Provider>;
  }
}

export default PlanItemHISTORYProvider;

PlanItemHISTORYProvider.defaultProps = {
  branchCode: "NY",
};
